import { Box } from '@mui/material';
import getRatio from '@/utils/getRatio';

export default function MapResponsive({ ratio, address }: any) {
  return (
    <Box
      component="span"
      sx={{
        width: 1,
        lineHeight: 1,
        display: 'block',
        overflow: 'hidden',
        position: 'relative',
        borderRadius: '5px',
        pt: getRatio(ratio),
        '& .wrapper': {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          lineHeight: 0,
          position: 'absolute',
          backgroundSize: 'cover !important',
        },
      }}
    >
      <Box className="wrapper">
        <iframe src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_KEY}&q=${address}`} style={{ width: '100%', height: '100%' }} loading="lazy" />
      </Box>
    </Box>
  );
}
